import { motion } from 'framer-motion';
import styled from 'styled-components';

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fluid: boolean;
  alignSelf?: string;
  disabled?: boolean;
  inverted?: boolean;
}

const Button = styled(motion.button)<any>`
  :focus {
    outline: 0px;
  }
  border: 2px solid #b5121b;
  background-color: #b5121b;
  color: white;
  border-radius: 5px;
  padding: 8px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  font-family: EffraRegular;
  flex: 1;
  width: ${props => (props.fluid ? '100%' : undefined)};
  align-self: ${props => (props.alignSelf ? props.alignSelf : 'flex-start')};
  margin: ${props => (props.margin ? props.margin : 0)};

  &:hover {
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.4;
    cursor: unset;
  }
  &:active {
    outline: 1px solid blue;
  }
`;

export const PrimaryButton = styled(Button)<IButtonProps>`
  border: 2px solid #b5121b;
  background-color: ${props => (props.inverted ? '#fff' : '#b5121b')};
  color: ${props => (props.inverted ? '#b5121b' : '#fff')};
`;

export const SecondaryButton = styled(Button)<IButtonProps>`
  border: 2px solid #4b7d94;
  background-color: ${props => (props.inverted ? '#fff' : '#4b7d94')};
  color: ${props => (props.inverted ? '#4b7d94' : '#fff')};
`;

export const SubmitButton = styled(Button)<IButtonProps>`
  border: 2px solid #75bf9a;
  background-color: ${props => (props.inverted ? '#fff' : '#75BF9A')};
  color: ${props => (props.inverted ? '#75BF9A' : '#fff')};
`;

export const OutlineButton = styled(Button)<IButtonProps>`
  border-width: 2px;
  border-style: solid;
  border-color: ${props => (props.borderColor ? props.borderColor : '#4b7d94')};
  color: ${props => (props.color ? props.color : '#4b7d94')};
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : 'transparent'};
  align-self: center;
`;
